/**
 * A class on `<body>`, for the length of a route.
 *
 * `mockups/client/login.html` is `<body class="splash">`, and `app.css` uses that
 * to turn the shell's flex row into a plain block with an ink background. In an
 * SPA there is one `<body>` for every route, so the class has to be added and
 * removed rather than authored — this is the one place the SPA reaches outside its
 * own root, and it is two lines so that it is the only one.
 */

import { useEffect } from 'react'

export function useBodyClass(className: string): void {
  useEffect(() => {
    document.body.classList.add(className)
    return () => {
      document.body.classList.remove(className)
    }
  }, [className])
}

/**
 * The tab's title. `shell.js` sets `document.title` from the topbar's own strings;
 * a page with no topbar — the splash — sets it here.
 */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    document.title = title
  }, [title])
}
